module.exports = __webpack_public_path__ + "img/建材行业数字化转型场景图谱.ccd1e18e.jpg";